module.exports = __webpack_public_path__ + "img/manual.020e6763.png";